const Loading = () => {
    return (<div className="__loading">
        <div className="spinner-border text-secondary" role="status">
        </div>
        <h1>Loading...</h1>
    </div>);
}

export default Loading;